export default {
	mounted() {
		this.bindAutofillWatch()
	},
	activated() {
		this.bindAutofillWatch()
	},
	deactivated() {
		this.unbindAutofillWatch()
	},
	beforeDestroy() {
		this.unbindAutofillWatch()
	},
	methods: {
		fieldOn(key, val) {
			return !!this.inputSelect[key] || !!(val && String(val).trim())
		},
		inputfocus(index) {
			this.$set(this.inputSelect, index, true)
		},
		inputblur(index) {
			this.$set(this.inputSelect, index, false)
		},
		toggleSecret(key) {
			this.$set(this.showSecret, key, !this.showSecret[key])
		},
		syncAutofillInputs() {
			const root = this.$el
			if (!root || typeof root.querySelectorAll !== 'function') return
			root.querySelectorAll('.ld-field-shell input').forEach((el) => {
				if (el.value) {
					el.dispatchEvent(new Event('input', { bubbles: true }))
				}
			})
		},
		onAutofillAnimation(e) {
			if (e.animationName !== 'ld-on-autofill') return
			const el = e.target
			if (el && el.tagName === 'INPUT' && el.value) {
				el.dispatchEvent(new Event('input', { bubbles: true }))
			}
		},
		bindAutofillWatch() {
			this.unbindAutofillWatch()
			this.$nextTick(() => {
				const root = this.$el
				if (root && root.addEventListener) {
					root.addEventListener('animationstart', this.onAutofillAnimation, true)
				}
				this.syncAutofillInputs()
				this._autofillTimer = setInterval(this.syncAutofillInputs, 200)
				this._autofillStop = setTimeout(() => {
					if (this._autofillTimer) {
						clearInterval(this._autofillTimer)
						this._autofillTimer = null
					}
				}, 3000)
			})
		},
		unbindAutofillWatch() {
			if (this._autofillTimer) {
				clearInterval(this._autofillTimer)
				this._autofillTimer = null
			}
			if (this._autofillStop) {
				clearTimeout(this._autofillStop)
				this._autofillStop = null
			}
			const root = this.$el
			if (root && root.removeEventListener) {
				root.removeEventListener('animationstart', this.onAutofillAnimation, true)
			}
		}
	}
}
